<template>
  <div>
    <el-dialog
      class="pop-group-dialog"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="60%"
      :title="$t('pop.choseGroup')"
    >
      <div class="group-filter clearfix">
        <div class="group-filter-module clearfix">
          <span class="module-name">{{ $t("pop.creatorTitle") }}</span>
          <span class="module-value">
            <el-input
              v-model="createName"
              :placeholder="$t('pop.creatorPlaceHolder')"
            ></el-input>
          </span>
        </div>
        <div class="group-filter-module clearfix">
          <span class="module-name">{{ $t("couse.groupName") }}</span>
          <span class="module-value">
            <el-input v-model="groupName" :placeholder="$t('user.input')"></el-input>
          </span>
        </div>
        <div class="group-filter-module group-filter-module2">
          <el-button
            class="tool-button tool-button-push"
            type="primary"
            @click="searchGroup"
          >
            {{ $t("query") }}
          </el-button>
        </div>
      </div>
      <div class="group-list">
        <el-table
          v-loading="dataListLoading"
          :data="dataList"
          ref="multipleTable"
          border
          class="jySelectionAll"
          style="width: 100%"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column
            type="selection"
            align="center"
            fixed="left"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column
            prop="groupName"
            :label="$t('couse.groupName')"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="groupIntro"
            :label="$t('couse.groupRemark')"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="creatBy"
            :label="$t('pop.creatorTitle')"
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <el-pagination
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <div class="group-footer">
        <el-button class="tool-button tool-button-info" type="info" @click="handleClose">
          {{ $t("course.return") }}
        </el-button>
        <el-button class="tool-button" type="primary" @click="saveGroup">
          {{ $t("pop.chose") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "competitionGroup",
  props: {
    dialogShow: {
      type: Boolean,
    },
    groupChose: {
      type: Array,
    },
  },
  data() {
    return {
      createName: "",
      groupName: "",
      dataList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      multipleSelection: [],
    };
  },
  methods: {
    handleClose() {
      this.multipleSelection = [];
      this.$emit("closeHandle", false);
    },
    pageSizeChangeHandle(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getDataList();
    },
    pageCurrentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    getRowKeys(row) {
      return row.groupId;
    },
    // table Checkbox方法
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },
    // 获取数据
    getDataList() {
      let params = {
        createName: this.createName,
        groupName: this.groupName,
        pageNo: this.pageNum,
        pageSize: this.pageSize,
        status:1
      };
      this.dataListLoading = true;
      this.$request
        .post("/sys/popsUpMsg/listGroup", params)
        .then((res) => {
          if (res) {
            this.total = res.totalCount;
            this.dataList = res.data;
            this.dataListLoading = false;
            let arr = this.multipleSelection.map((item) => {
              return item.groupId;
            });
            console.log(this.groupChose)
            if (this.groupChose && this.groupChose.length > 0) {
              this.groupChose
                .forEach((item) => {
                  if (!arr.includes(item.groupId)) {
                    this.multipleSelection.push(item);
                    this.$refs.multipleTable.toggleRowSelection(item, true);
                  }
                });
            }
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 保存选择的群组
    saveGroup() {
      this.$emit("saveGroup", this.multipleSelection);
      this.handleClose();
    },
    searchGroup() {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
  },
  mounted() {
    this.multipleSelection = [];
    this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.pop-group-dialog {
  .group-filter {
    .group-filter-module {
      height: 34px;
      line-height: 34px;
      float: left;
      margin-right: 20px;
      &.group-filter-module2 {
        float: right;
        margin: 0;
      }
      .module-name {
        display: block;
        float: left;
        height: 100%;
        text-align: left;
      }
      .module-value {
        display: block;
        float: left;
        height: 100%;
        margin-left: 10px;
      }
    }
  }
  .group-list {
    margin-top: 20px;
  }
  .group-footer {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
